<div [ngClass]="item.size">
    <div class='embed-responsive embed-responsive-16by9'>
        <iframe class="embed-responsive-item" [src]="'https://www.youtube.com/embed/'+ item.video +'?rel=0'|safe" allowfullscreen></iframe>
    </div>
</div>